import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import {
  preview,
  purchase,
} from './api';
import {
  CHECKOUT_PREVIEW,
  CHECKOUT_PURCHASE,
  RESET_CHECKOUT_PREVIEW,
  RESET_COUPON_CODE,
  SAVE_COUPON_CODE,
  SET_APPLYING_COUPON,
} from './types';
import { getAccountParams } from '../billing-info/utils';

export const resetCouponCode = createAction(RESET_COUPON_CODE);
export const saveCouponCode = createAction(SAVE_COUPON_CODE);
export const setApplyingCoupon = createAction(SET_APPLYING_COUPON);

export const checkoutPreviewAction = createApiAction(
  // plan has plan_code and add_ons list
  CHECKOUT_PREVIEW,
  ({ coupon, plans, token, values }) => preview({
    account: getAccountParams(token, values),
    coupon_code: coupon,
    plans,
  }),
);

export const checkoutPurchaseAction = createApiAction(
  CHECKOUT_PURCHASE,
  ({ coupon, plans, token, values, threeDsTokenId }) => purchase({
    account: getAccountParams(token, values, threeDsTokenId),
    coupon_code: coupon,
    plans,
  }),
);

export const resetPreviewAction = createAction(RESET_CHECKOUT_PREVIEW);
